module.exports = __webpack_public_path__ + "static/img/banner-mobile-2.81caf9bc.jpg";